import React, { useCallback } from 'react';
import { useProctor } from '../../context/ProctorContext';
import { useEventLogContext } from '../../context/EventLogContext';
import { timeStr } from '../../engine/stats';

export function SceneFeed() {
  const { detectedScenes, config } = useProctor();
  const { setHighlightWindow } = useEventLogContext();

  const cautionCount = detectedScenes.filter(d => d.scene.severity !== 'NORMAL').length;
  const normalCount = detectedScenes.filter(d => d.scene.severity === 'NORMAL').length;

  const handleSceneClick = useCallback((sceneTime: number) => {
    const windowMs = config.adjacentSec * 1000;
    setHighlightWindow({ start: sceneTime - windowMs, end: sceneTime });
  }, [config.adjacentSec, setHighlightWindow]);

  return (
    <div className="scene-section">
      <h3>
        장면 기록 (Scene Log) — {detectedScenes.length}건
        {detectedScenes.length > 0 && ` (주의 ${cautionCount} / 일반 ${normalCount})`}
      </h3>
      {detectedScenes.length === 0 ? (
        <div className="scene-empty">모니터링 시작 후 관찰된 장면이 표시됩니다</div>
      ) : (
        detectedScenes.map((d, i) => {
          const isNormal = d.scene.severity === 'NORMAL';
          return (
            <div
              key={i}
              className={`scene-item ${d.scene.severity}`}
              onClick={() => handleSceneClick(d.t)}
            >
              <span className="scene-icon">{d.scene.icon}</span>
              <div className="scene-body">
                <div className="scene-title">
                  <span className={`scene-type-badge ${isNormal ? 'scene-type-normal' : 'scene-type-caution'}`}>
                    {isNormal ? '정상적인 시험 행동' : '주의가 필요한 행동'}
                  </span>
                  {d.scene.label}
                </div>
                <div className="scene-desc">{d.scene.desc}</div>
                {d.channels.length > 0 && (
                  <div className="scene-evidence">증거 채널: {d.channels.join(' + ')}</div>
                )}
              </div>
              <span className="scene-time">{timeStr(d.t)}</span>
            </div>
          );
        })
      )}
    </div>
  );
}
